export var DynamicBehaviorType;
(function (DynamicBehaviorType) {
    DynamicBehaviorType[DynamicBehaviorType["HorizontalTranslation"] = 0] = "HorizontalTranslation";
    DynamicBehaviorType[DynamicBehaviorType["VerticalTranslation"] = 1] = "VerticalTranslation";
    DynamicBehaviorType[DynamicBehaviorType["Rotation"] = 2] = "Rotation";
})(DynamicBehaviorType || (DynamicBehaviorType = {}));
